import { render } from "./CloseRitDialog.vue?vue&type=template&id=33ec8410&ts=true"
import script from "./CloseRitDialog.vue?vue&type=script&lang=ts"
export * from "./CloseRitDialog.vue?vue&type=script&lang=ts"

import "./CloseRitDialog.vue?vue&type=style&index=0&id=33ec8410&lang=scss"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__